import './Button.scss';
import PropTypes from 'prop-types';

// General Button Component
const Button = ({ buttonType, label, onClick, disabled }) => {
  return (
    <button
      className={`button_component ${buttonType} ${disabled ? 'disabled' : ''}`}
      disabled={disabled}
      data-testid={`button-${label}`}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

Button.propTypes = {
  buttonType: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default Button;
